import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, computed } from "vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Autoplay } from "swiper";
// 注册模块（Swiper 9 必须）
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
// swiper

export default /*@__PURE__*/_defineComponent({
  __name: 'ourBusiness',
  setup(__props) {

SwiperCore.use([Pagination, Autoplay]);
// 引入样式
const swiperModules = [Pagination, Autoplay];




onMounted(() => {
  // 这段代码的主要功能是根据用户在页面上的滚动位置动态地为导航栏添加或移除阴影效果。具体来说，
  // 当页面的垂直滚动距离大于 100 像素时，导航栏会显示一个中等大小的阴影，使其在页面滚动时更加突出，
  // 提升用户体验。当滚动距离小于或等于 100 像素时，阴影效果会被移除，从而使页面顶部看起来更加简洁。
  // window.addEventListener("scroll", () => {
  //   const nav = document.querySelector("nav");
  //   if (window.scrollY > 100) {
  //     nav?.classList.add("shadow-md");
  //   } else {
  //     nav?.classList.remove("shadow-md");
  //   }
  // });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _cache[0] || (_cache[0] = [
    _createStaticVNode("<section class=\"py-20 bg-gray-50\" data-v-0efdbf12><div class=\"container mx-auto px-6\" data-v-0efdbf12><h2 class=\"text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4\" data-v-0efdbf12> 骑行装备全品类供应 </h2><div class=\"w-20 h-1 bg-yellow-400 mx-auto mb-6\" data-v-0efdbf12></div><p class=\"text-center text-gray-600 mb-16 max-w-3xl mx-auto\" data-v-0efdbf12> 从入门级到专业级，覆盖骑行全场景装备需求 </p><div class=\"grid grid-cols-1 md:grid-cols-2 gap-8 text-left\" data-v-0efdbf12><div data-v-0efdbf12><h3 class=\"text-2xl font-bold mb-4\" data-v-0efdbf12>核心装备</h3> 轻量化碳纤维车架、空气动力学轮组、人体工学坐垫，适配公路、山地、通勤等不同骑行场景，每款产品均经过专业骑手实测优化。 </div><div data-v-0efdbf12><h3 class=\"text-2xl font-bold mb-4\" data-v-0efdbf12>穿戴防护</h3> 透气排汗骑行服、防紫外线骑行镜、多档调节头盔，兼顾功能性与设计感，让安全与舒适同行 </div><div data-v-0efdbf12><h3 class=\"text-2xl font-bold mb-4\" data-v-0efdbf12>智能配件</h3> GPS 码表、心率监测手环、车灯套装，通过科技赋能提升骑行体验，记录每一段旅程的数据与故事 </div></div></div></section><div class=\"container mx-auto px-4 py-20\" data-v-0efdbf12><h2 class=\"text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4\" data-v-0efdbf12> 骑行场景解决方案 </h2><div class=\"w-20 h-1 bg-yellow-400 mx-auto mb-6\" data-v-0efdbf12></div><p class=\"text-center text-gray-600 mb-16 max-w-3xl mx-auto\" data-v-0efdbf12> 不止于装备，更致力于构建完整骑行生态 </p><div class=\"grid grid-cols-1 md:grid-cols-2 gap-8 text-left\" data-v-0efdbf12><div data-v-0efdbf12><h3 class=\"text-2xl font-bold mb-4\" data-v-0efdbf12>社群骑行活动</h3> 每周组织新手训练营、周末短途骑行、季度主题挑战赛，从技巧教学到团队远征，让独行侠找到同路人，让初学者快速融入圈子 </div><div data-v-0efdbf12><h3 class=\"text-2xl font-bold mb-4\" data-v-0efdbf12>骑行技能培训</h3> 开设车辆保养、应急处理、体能提升等课程，由资深骑手与运动教练联合授课，让每个人都能科学骑行、安全出发 </div></div></div><section id=\"leadershipTeam\" class=\"py-20 bg-gray-50\" data-v-0efdbf12><div class=\"container mx-auto px-6\" data-v-0efdbf12><h2 class=\"text-3xl md:text-4xl font-bold text-center text-gray-800 mb-4\" data-v-0efdbf12> 骑行文化传播与共创 </h2><div class=\"w-20 h-1 bg-yellow-400 mx-auto mb-6\" data-v-0efdbf12></div><p class=\"text-center text-gray-600 mb-16 max-w-3xl mx-auto\" data-v-0efdbf12> 我们相信骑行是一种生活方式，更是连接人与自然的纽带 </p><div class=\"grid grid-cols-1 md:grid-cols-2 gap-8 text-left\" data-v-0efdbf12><div data-v-0efdbf12> 运营线上骑行网站,分享骑行故事、装备测评、路线攻略，让热爱者在这里获取养分 </div><div data-v-0efdbf12> 发起 “骑行计划”，通过环保骑行活动倡导绿色出行，让骑行更有价值。 </div><div data-v-0efdbf12> 搭建骑行装备共创平台，邀请资深骑友参与产品迭代建议，让装备更懂骑手，让需求直达生产端。 </div></div></div></section>", 3)
  ])))
}
}

})